export const formatNumberAsCurrency = ({
  value,
  currency = "USD",
}: {
  value: number;
  currency: string;
}) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
    // Use the local/narrow symbol (e.g. ZAR → "R", CAD → "$") instead of the
    // en-US default, which falls back to the ISO code for currencies with no
    // en-US glyph (ZAR rendered as "ZAR"). Falls back to the regular symbol
    // when no narrow form exists.
    currencyDisplay: "narrowSymbol",
  }).format(value);

export const formatLargeCurrencyValue = (amount: number) => {
  // Convert to absolute value
  const absoluteAmount = Math.abs(amount);

  // Define suffixes for different scales
  const suffixes = [
    { value: 1e12, suffix: "T" }, // Trillion
    { value: 1e9, suffix: "B" }, // Billion
    { value: 1e6, suffix: "M" }, // Million
    { value: 1e3, suffix: "K" }, // Thousand
  ];

  // Iterate over suffixes to find the right format
  for (let i = 0; i < suffixes.length; i++) {
    if (absoluteAmount >= suffixes[i].value) {
      return (amount / suffixes[i].value).toFixed(2) + suffixes[i].suffix;
    }
  }

  // If the amount is less than 1000, return it with no formatting
  return amount.toString();
};
